import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  HStack,
  Card,
  RadioGroup,
  Stack,
} from '@chakra-ui/react';

function NewQuote() {
  const navigate = useNavigate();
  const [projectType, setProjectType] = useState('wordpress');

  const handleStartChat = async () => {
    // TODO: Create chat session via API
    // For now, navigate to chat with mock session ID
    navigate('/chat/new-session');
  };

  return (
    <Box maxW="2xl" mx="auto">
      <VStack gap={8} align="stretch">
        <VStack align="start" gap={2}>
          <Heading>Start a New Quote</Heading>
          <Text color="gray.600">
            Let's begin by understanding your project needs
          </Text>
        </VStack>

        <Card.Root>
          <Card.Body>
            <VStack gap={6} align="stretch">
              <VStack align="start" gap={3}>
                <Text fontWeight="bold" fontSize="lg">
                  What type of website do you need?
                </Text>
                <RadioGroup.Root value={projectType} onValueChange={(e) => setProjectType(e.value || 'wordpress')}>
                  <Stack gap={3}>
                    <RadioGroup.Item value="wordpress">
                      <RadioGroup.ItemControl />
                      <RadioGroup.ItemText>
                        <VStack align="start" gap={1}>
                          <Text fontWeight="medium">WordPress Website</Text>
                          <Text fontSize="sm" color="gray.600">
                            Standard business or blog website
                          </Text>
                        </VStack>
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>

                    <RadioGroup.Item value="ecommerce">
                      <RadioGroup.ItemControl />
                      <RadioGroup.ItemText>
                        <VStack align="start" gap={1}>
                          <Text fontWeight="medium">E-commerce Store</Text>
                          <Text fontSize="sm" color="gray.600">
                            Online store with WooCommerce
                          </Text>
                        </VStack>
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>

                    <RadioGroup.Item value="redesign">
                      <RadioGroup.ItemControl />
                      <RadioGroup.ItemText>
                        <VStack align="start" gap={1}>
                          <Text fontWeight="medium">Website Redesign</Text>
                          <Text fontSize="sm" color="gray.600">
                            Refresh your existing website
                          </Text>
                        </VStack>
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>

                    <RadioGroup.Item value="migration">
                      <RadioGroup.ItemControl />
                      <RadioGroup.ItemText>
                        <VStack align="start" gap={1}>
                          <Text fontWeight="medium">Website Migration</Text>
                          <Text fontSize="sm" color="gray.600">
                            Move your site to new hosting
                          </Text>
                        </VStack>
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>

                    <RadioGroup.Item value="custom">
                      <RadioGroup.ItemControl />
                      <RadioGroup.ItemText>
                        <VStack align="start" gap={1}>
                          <Text fontWeight="medium">Custom Project</Text>
                          <Text fontSize="sm" color="gray.600">
                            Something else? Let's discuss
                          </Text>
                        </VStack>
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>
                  </Stack>
                </RadioGroup.Root>
              </VStack>

              <HStack gap={4} pt={4}>
                <Button
                  colorScheme="brand"
                  size="lg"
                  flex={1}
                  onClick={handleStartChat}
                >
                  Continue to Chat
                </Button>
              </HStack>
            </VStack>
          </Card.Body>
        </Card.Root>

        <Card.Root variant="subtle">
          <Card.Body>
            <VStack gap={3} align="start">
              <Text fontWeight="bold">How it works:</Text>
              <VStack align="start" gap={2} pl={4}>
                <Text fontSize="sm">
                  1. Chat with our AI assistant about your project
                </Text>
                <Text fontSize="sm">
                  2. Share examples, files, or website URLs
                </Text>
                <Text fontSize="sm">
                  3. Get an instant, detailed quote
                </Text>
                <Text fontSize="sm">
                  4. Review and adjust as needed
                </Text>
              </VStack>
            </VStack>
          </Card.Body>
        </Card.Root>
      </VStack>
    </Box>
  );
}

export default NewQuote;